import { gql } from '@apollo/client';
import { FIND_CACHE_FRAGMENT } from './getMyFindsQuery';

export const CommitStandardImportMutationName = 'CommitStandardImport';

export const COMMIT_STANDARD_IMPORT_MUTATION = gql`
  mutation ${CommitStandardImportMutationName}($id: ID!) {
    commitStandardImport(id: $id) {
      standardImport {
        id
        status
        completedAt
        committedFindIds
        committedFieldSessionIds
      }
      createdFindCount
      createdFindIds
      createdFinds {
        ...FindCacheFields
      }
      createdFieldSessionCount
      createdFieldSessionIds
    }
  }
  ${FIND_CACHE_FRAGMENT}
`;
